import api from '@/api/client';
import { CreateMemberPayload } from '@/types/interfaces';

export function createMember(payload: CreateMemberPayload) {
  return api.post('/create-organization-member', payload);
}
